module.exports = __webpack_public_path__ + "img/card-cigar.3100297b.webp";